import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import merge from 'lodash/merge'
import { SlidePanelProps } from './SlidePanel.types'

const SlidePanel: React.FC<SlidePanelProps> = ({
    closeOnExternalClick = false,
    children,
    noSpacing,
    width,
    show,
    pos = 'right',
    setShow,
    style,
}) => {
    const ref = useRef(null)
    const [_width, setWidth] = useState(null)
    const [mountComplete, setMountComplete] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            if (ref.current) {
                const bound = ref?.current?.getBoundingClientRect() ?? {}
                setWidth(bound.width)
                setTimeout(() => {
                    setMountComplete(true)
                }, 1000)
            }
        }, 1000)
    }, [show])

    const variants = {
        open: { right: noSpacing ? 0 : '15px' },
        closed: { right: _width * -1 - 200 + 'px' },
    }
    // const variants = {
    //     open: { right: '15px' :  },
    //     closed: { right: mountComplete ? width * -1 + 'px' : '-5000px' },
    // }

    const _style = {
        top: noSpacing ? 0 : '15px',
        bottom: noSpacing ? 0 : '15px',
        // right: _width * -1 - 300 + 'px ',
        // '-4000px',
    }

    const contentStyle = {
        width: width || '100%',
        borderRadius: noSpacing ? 0 : '4px',
    }

    const handleAutoClose = (e) => {
        if (!ref.current.contains(e.target)) {
            if (!setShow) {
                throw Error('setShow is not defined')
            }
            setShow(false)
        }
    }

    useEffect(() => {
        if (show && closeOnExternalClick) {
            document.addEventListener('click', handleAutoClose)
        }
        return () => {
            document.removeEventListener('click', handleAutoClose)
        }
    }, [show, closeOnExternalClick])

    return (
        <motion.div
            style={merge(_style)}
            initial={false}
            animate={show ? 'open' : 'closed'}
            variants={variants}
            data-testid='SlidePanel'
            className={`r-slidepanel-container ${mountComplete ? 'r-mounted' : ''}`}
        >
            <div className={'r-panel-contents'} style={merge(style, contentStyle)} ref={ref}>
                {children}
            </div>
        </motion.div>
    )
}

export default SlidePanel
